import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { IFormCondition, IFormConditionEditorDialogData } from '@fi-shared/fi-form-shared/fi-form-shared';
import { cloneDeep, isDefined } from '@fi-shared/utils';
import { FiFormConditionHelperService } from '@fi-shared/fi-form-shared/fi-form-condition-helper.service';
import { FiValuesComparison } from '@fi-shared/utils/fi-values-comparison';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { Subject } from 'rxjs';

@Component({
    selector: 'fi-form-logic-condition-editor-dialog',
    templateUrl: './fi-form-logic-condition-editor-dialog.component.html',
    styleUrls: ['./fi-form-logic-condition-editor-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-form-logic-condition-editor-dialog' },
    standalone: false,
})
export class FiFormLogicConditionEditorDialogComponent
    extends FiDialogsContentBase<IFormConditionEditorDialogData, IFormCondition>
    implements OnInit, OnDestroy
{
    condition: IFormCondition;
    private formConditionHelperService: FiFormConditionHelperService;
    private fiDialogsService: FiDialogsService;
    fiValuesComparison: FiValuesComparison<IFormCondition>;

    ngOnInit(): void {
        this.cloneSourceCondition();
        this.setServices();
        this.fiValuesComparison = new FiValuesComparison(() => this.condition);
        this.subscribeOnTransitionCloseDialog(this.fiDialogsService, this.ngOnDestroy$);
    }

    private cloneSourceCondition() {
        this.condition = cloneDeep(this.data.condition);
    }

    onConditionChange($event: IFormCondition) {
        this.condition = cloneDeep($event);
    }

    getResult(): IFormCondition {
        return this.condition;
    }

    getNoButtonClickPromise(): Promise<{ canClose: boolean }> {
        return this.fiDialogsService.getCanCloseConfirmation(!this.fiValuesComparison.isChanged());
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }

    private setServices() {
        this.formConditionHelperService = this.injector.get(FiFormConditionHelperService);
        this.fiDialogsService = this.injector.get(FiDialogsService);
    }
}
